import { render } from "./Checkbox.vue?vue&type=template&id=a6e22c76&scoped=true"
import script from "./Checkbox.vue?vue&type=script&lang=js"
export * from "./Checkbox.vue?vue&type=script&lang=js"

import "./Checkbox.vue?vue&type=style&index=0&id=a6e22c76&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-a6e22c76"

export default script